/**
 * 年度入职人数趋势组件
 */

import { useEffect, useState } from 'react';
import { message } from 'antd';
import $ from 'jquery';
import { Chart } from '@antv/g2';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const UserUDATC = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [orgInfosLists, setOrgInfosLists] = useState([]);
    const [orgInfoULID, setOrgInfoULID] = useState('');
    const [data, setData] = useState([]);

    useEffect(() => {
        /**
         * 获取组织下拉列表
         * props.data为真，则是通过Chat调用传数据
         */
        if (!props.data && !orgInfosLists.length) {
            $.ajax({
                url: `${CNF.api}org/infos?rss=list`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOrgInfosLists(data.dat);
                            setOrgInfoULID(data.dat[0].key);
                            setIsRefresh(true);//  刷新数据
                        }
                    } else {
                        message.error(data.msg);
                    }
                }
            })
        }
    }, [props.data, orgInfosLists.length])

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh && orgInfoULID) {
                //  获取数据
                const params = {
                    'org_info_ulid': orgInfoULID,
                }
                $.ajax({
                    url: `${CNF.api}reports/user/utecy${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            if (data.dat.length) {
                                setData(data.dat);
                            }
                            setIsRefresh(false);
                        } else {
                            message.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [props, data, isRefresh, orgInfoULID]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '年度入职人数趋势',
            subtitle: '展示每年入职人数趋势走势。',
        });

        chart.data(data);

        chart
            .encode('x', 'year')
            .encode('y', 'count')
            .scale('y', {
                domainMin: 0,
                nice: true,
                tickCount: 4,
            });

        chart.line()
            // .encode('color', 'year')
            // .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches.default,
            })
            .axis('x', { title: '年份', })
            .axis('y', { title: '', labelFormatter: (d) => (d) })
            .animate('enter', {
                type: 'pathIn',
                duration: CNF.animateDuration,
            },)
            .tooltip((data) => ({
                name: data.type,
                value: `${data.count}`,
            }))
            .style('lineWidth', 1);

        chart.point().style('fill', 'white').tooltip(false);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props.collapsed, data]);

    return <div id='antv-g2-id'></div>;
}

export default UserUDATC;